import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate, useParams, Link } from 'react-router-dom'
import { ChangeStatusOutletUser, GetOutletUserList, DeleteOutletUser, ResendCredential, ExportUsers } from '../../../services/company_panel/platform_user/platformUserService';
import Swal from 'sweetalert2'
import CustomPagination from '../../../components/company_panel/common/custompagination'
import { formateDate, getCompany, checkPermission, capitalizeFirstLetter, TrimText } from '../../../helpers/commonFunctions';
import Sorting from '../../../components/company_panel/common/sorting';
import Loader from '../../../components/company_panel/common/loader'
import StatusFilter from '../../../components/company_panel/common/statusFilter'
import { showFilterlist } from '../../../utils/Constants'
import CustomRangepicker from '../../../components/company_panel/common/rangepicker'
import $ from "jquery";
import notFound from '../../../assets/company/img/no-record-found.png'
import { usePersistedListState } from '../../../hooks/usePersistedListState';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


const OutletUserList = () => {
    const breadcrumbs = [{ title: "Dashboard", url: "/company/dashboard" }, { title: "Pages", url: "" },];
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();
    // persisted filters (page lives in the route) — restored on return from add/edit/view
    const { saved, save, clear } = usePersistedListState('outlet_users');
    const [list, setList] = useState([]);
    const [statsUpdate, setStatusUpdate] = useState("false");
    const [dataLength, setDataLength] = useState();
    const [itemPerPage, setItemPerPage] = useState(saved?.itemPerPage || 10);
    const [sorting, setSorting] = useState(saved?.sorting || {});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(Number(params?.id) || 1);
    const [loader, setLoader] = useState(true);
    const [search, setSearch] = useState(saved?.search || {});
    const [globalSearch, setGlobalSearch] = useState(saved?.globalSearch || "");
    const [resetdate, setResetDate] = useState(false);
    const [exporting, setExporting] = useState(false);


    useEffect(() => {
        if (search) {
            setLoader(true)
            const formData = new FormData()
            formData.append("page", page)
            formData.append("per_page", itemPerPage)
            formData.append("sort", JSON.stringify(sorting))
            formData.append("search", JSON.stringify(search))
            formData.append("global_search", globalSearch)
            formData.append('company_id', getCompany().company_id);
            GetOutletUserList(formData).then(data => {
                setDataLength(data.data.response.count);
                setList(data && data.data && data.data.response ? data.data.response.rows : [])

                setLoader(false)
            }).catch(error => {
                console.log("error ====> ", error);
            })
        }
    }, [location, statsUpdate, sorting, search, globalSearch])

    // persist filters on every change (page lives in the route, not the store)
    useEffect(() => {
        save({ itemPerPage, sorting, search, globalSearch });
    }, [itemPerPage, sorting, search, globalSearch])


    const resetFilter = (e) => {
        e.preventDefault()
        setGlobalSearch("")
        setSearch({})
        setResetDate(!resetdate)
        clear()
        $("#defaultstatus").prop("selectedIndex", 0)
    }

    function deleteFunction(row) {
        Swal.fire({
            customClass: 'swal-wide',
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f9bff',
            cancelButtonColor: '#dc3545',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {

                DeleteOutletUser(row).then(data => {
                    if (data.status === 200) {
                        Swal.fire({
                            customClass: 'swal-wide',
                            position: 'absolute',
                            icon: 'success',
                            title: 'User deleted successfully',
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        })
                        setStatusUpdate(!statsUpdate)
                    }
                }).catch(error => {
                    console.log("deleteError",error);
                })
            }
        })
    }

    const ChangeStatus = (row, Num) => {
        const formData = new FormData()
        formData.append("id", row)
        formData.append("status", Num)
        Swal.fire({
            customClass: 'swal-wide',
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f9bff',
            cancelButtonColor: '#dc3545',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                ChangeStatusOutletUser(formData).then(data => {
                    if (data.status === 200) {
                        Swal.fire({
                            customClass: 'swal-wide',
                            position: 'absolute',
                            icon: 'success',
                            title: data.data.message,
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        })
                        setStatusUpdate(!statsUpdate)
                    }
                }).catch(error => {
                    console.log("error===>",error);
                })
            }
        })
    }

    // resend credential
    const resendCredential = (row) => {
        const formData = new FormData()
        formData.append("id", row?.id)
        Swal.fire({
            customClass: 'swal-wide',
            title: 'Do you want to resend Credential?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f9bff',
            cancelButtonColor: '#dc3545',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                ResendCredential(formData).then(data => {
                    if (data.status === 200) {
                        Swal.fire({
                            customClass: 'swal-wide',
                            position: 'absolute',
                            icon: 'success',
                            title: data.data.message,
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        })
                    }
                }).catch(error => {
                    console.log("error===>",error)
                })
            }
        })
    }

    const viewFunction = (row) => {
        navigate(`/company/business/platform-User/outlet-user/${page}/view/${row}`)
    }
    const editFunction = (row) => {
        navigate(`/company/business/platform-User/outlet-user/${params.id}/edit/${row.id}`)
    }

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    }

    // search or filter function
    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    }
    // search or filer end
    const copyOutletFunction = (row) => {
        navigate(`/company/business/platform-User/outlet-user/${params.id}/edit/${row.id}?copy=true`);
    }

    // Exports every user the current filters match, from the export endpoint
    // rather than the paged listing, so there is no page size to size up first.
    const handleExport = () => {
        setExporting(true)
        const formData = new FormData()
        formData.append("sort", JSON.stringify(sorting))
        formData.append("search", JSON.stringify(search))
        formData.append("global_search", globalSearch)
        formData.append('company_id', getCompany().company_id);
        ExportUsers(formData).then(data => {
            const response = data?.data?.data || data?.data?.response
            const rows = response?.rows || [];
            if (!rows.length) {
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: 'error',
                    title: 'There are no users to export',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true,
                    position: 'top-right',
                })
                return
            }
            // areas and outlets come back either as a list or as a plain string.
            const asText = (value) => {
                if (Array.isArray(value)) return value.filter(Boolean).join(', ') || 'N/A';
                return value || 'N/A';
            }
            const sheetRows = rows.map(row => ({
                'First Name': row?.first_name ? capitalizeFirstLetter(row.first_name) : 'N/A',
                'Last Name': row?.last_name ? capitalizeFirstLetter(row.last_name) : 'N/A',
                'Email': row?.email || 'N/A',
                'Mobile': row?.mobile || 'N/A',
                'Employee Id': row?.employee_id || 'N/A',
                // The column is numeric, so a PIN like 0330 arrives as 330. PINs are
                // always four digits, so pad it back and keep it as text.
                'PIN': row?.user_login_pin == null || row?.user_login_pin === '' ? 'N/A' : String(row.user_login_pin).padStart(4, '0'),
                'Role': row?.role?.name ? capitalizeFirstLetter(row.role.name) : 'N/A',
                'Created At': row?.created_at ? formateDate(row.created_at) : 'N/A',
                'Areas': asText(row?.areas),
                'Outlets': asText(row?.outlets),
            }))
            const header = ['First Name', 'Last Name', 'Email', 'Mobile', 'Employee Id', 'PIN', 'Role', 'Created At', 'Areas', 'Outlets']
            const ws = XLSX.utils.json_to_sheet(sheetRows, { header })
            ws['!cols'] = [{ wch: 18 }, { wch: 18 }, { wch: 34 }, { wch: 16 }, { wch: 14 }, { wch: 10 }, { wch: 18 }, { wch: 18 }, { wch: 30 }, { wch: 40 }]
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, ws, 'Users')
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
            saveAs(new Blob([excelBuffer], { type: 'application/octet-stream' }), 'users.xlsx')
        }).catch(error => {
            console.log("error ====> ", error);
            Swal.fire({
                customClass: 'swal-wide',
                icon: 'error',
                title: error?.response?.data?.message || 'Could not export users',
                showConfirmButton: false,
                timer: 5000,
                toast: true,
                position: 'top-right',
            })
        }).finally(() => {
            setExporting(false)
        })
    }

    return (
        <>
            <div className="animation_fade">
                <div className='page-header d-flex align-items-center'>
                    <div className='page-header-left'>
                        <h4>Platform User</h4>
                    </div>
                    <div className='page-header-right ms-auto d-flex align-items-center gap-2'>
                        <button className="btn btn-outline-primary" type="button" onClick={handleExport} disabled={exporting}>
                            {exporting ? 'Exporting...' : 'Export'}
                        </button>
                        {checkPermission('store_platform_users', 'add') ?
                            <button className="btn btn-primary" onClick={() => navigate(`/company/business/platform-User/outlet-user/${page}/add`)}>Create User</button>
                            : ''}
                    </div>
                </div>
                <div className="card custom-card overflow-hidden">
                    <div className='gap-20 border-bottom'>
                        <div className='d-flex justify-content-between align-items-center'>
                            <ul className="d-flex setting w-100 mb-0 p-0">
                                {checkPermission('store_platform_users', 'view') && (
                                    <li className="active"><Link to={`/company/business/platform-User/outlet-user/list/${1}`} className="btn btn-primary">Outlet Users</Link></li>
                                )}
                                {checkPermission('store_roles', 'view') && (
                                    <li className="ms-3"><Link to={`/company/business/platform-User/role/list/${1}`} className="btn">Roles</Link></li>
                                )}
                            </ul>
                        </div>
                    </div>
                    <div className='gap-20'>
                        <div className='filter-header d-flex justify-content-between align-items-center'>
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="form-group mb-0 rangepicker_container">
                                    <input type="search" className="form-control" value={globalSearch} placeholder="Search" onChange={(e) => { setGlobalSearch(e.target.value) }} />
                                </div>
                            </div>
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="date-input">
                                    <CustomRangepicker GetDateRange={(e) => { prepareSearch("created", e) }} resetdate={resetdate} />
                                </div>
                                <StatusFilter data={showFilterlist} prepareSearch={prepareSearch} value={search.status === undefined ? '' : String(search.status)} />
                                <button type="reset" value='Reset' onClick={resetFilter} className="btn btn-primary mr-2">Reset Filter</button>
                            </div>
                        </div>
                    </div>


                    <div className="tabler-wrap">
                        <div className="table-responsive">
                            <table className="table table-custom">
                                <thead>
                                    <tr>
                                        <th width="5%">
                                            <div className='d-inline-flex align-items-start'>
                                                <span className='me-2'>Id</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="id" />
                                            </div>
                                        </th>
                                        <th width="25%" className='text-start'>
                                            <div className='d-inline-flex align-items-start'>
                                                <span className='me-2'>Name</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="first_name" />
                                            </div>
                                        </th>


                                        <th width="20%">
                                            <div className='sorting_column'>
                                                <span>Email </span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="email" />
                                            </div>
                                        </th>
                                        <th width="20%">
                                            <span>Role</span>
                                        </th>
                                        <th className="created_head" width="15%">
                                            <div className='sorting_column'>
                                                <span>Created Date</span>
                                                <Sorting sort={sorting} handleSort={handleSort} defaultSorting={defaultSorting} column="created_at" />
                                            </div>
                                        </th>
                                        <th className='status_head' width="10%">Status</th>
                                        <th className='action_head text-end' width="10%">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ?
                                        <tr>
                                            <td colSpan={11}><Loader /></td>
                                        </tr> : <>
                                            {list.length ? list.map((row, i) => (
                                                <tr key={i}>
                                                    <td>{row.id}</td>
                                                    <td className='d-flex align-items-center'>
                                                        <div className='avatar avatar-xs me-4'>
                                                            {row.profile_image ? <img src={row.profile_image} alt={`${row.first_name} ${row.last_name}`} /> : ''}
                                                        </div>
                                                        <span className='ps-1'>
                                                            {capitalizeFirstLetter(row?.first_name + " " + row?.last_name)}
                                                        </span>
                                                    </td>

                                                    <td>{TrimText(row.email, 30)}</td>
                                                    <td>{capitalizeFirstLetter(row?.rolename)}</td>
                                                    <td>{row.created_at ? formateDate(row.created_at) : "N/A"}</td>
                                                    <td>
                                                        <div className="form-check form-switch w-25">
                                                            <input className="form-check-input" type="checkbox" id="status-change" name="status" checked={row.status == 1 ? 'checked' : ''} onClick={() => { ChangeStatus(row.id, row.status == 1 ? 0 : 1) }} />
                                                            <label className="form-check-label" for="status-change"></label>
                                                        </div>
                                                    </td>
                                                    <td className='text-end'>
                                                        <div className="dropdown  d-inline-block">
                                                            <button className="btn btn-icon btn-secondary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i className='ti ti-dots-vertical'></i>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                                {checkPermission('store_platform_users', 'view') ?
                                                                    <li><div className='dropdown-item' onClick={() => { viewFunction(row.id) }}><i className="ti ti-eye" aria-hidden="true"></i> View details</div></li>
                                                                    : ''}
                                                                {row.roleslug != 'company_admin' && checkPermission('store_platform_users', 'edit') ?
                                                                    <li><div className='dropdown-item' onClick={() => { editFunction(row) }}><i className="ti ti-edit" aria-hidden="true"></i> Edit</div></li>
                                                                    : ''}
                                                                {row.roleslug != 'company_admin' && checkPermission('store_platform_users', 'delete') ?
                                                                    <li> <div className='dropdown-item' onClick={() => { deleteFunction(row.id) }}><i className="ti ti-trash" aria-hidden="true"></i> Delete</div></li>
                                                                    : ''}
                                                                {checkPermission('store_platform_users', 'add') ?
                                                                    <li> <div className='dropdown-item' onClick={() => { copyOutletFunction(row) }}><i className="ti ti-copy" aria-hidden="true"></i> Copy user</div></li>
                                                                    : ''}
                                                                <li><div className='dropdown-item' onClick={() => { resendCredential(row) }}><i className="ti ti-reload" aria-hidden="true"></i>Send credential</div></li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )) : <tr>
                                                <td colSpan={11} className="text-center">
                                                    <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                    <p>No Record.</p>
                                                </td>
                                            </tr>}</>}
                                </tbody>
                            </table>
                        </div>
                        <div className='tabler-footer'>
                            <div className='d-flex align-items-center'>
                                <div id="example1_info" role="status" className="table-result" aria-live="polite">
                                    <b>Total Records : {dataLength ? dataLength : "0"}</b>
                                </div>
                                {dataLength && dataLength > 0 ?
                                    <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "outlet-management", path: "/company/business/platform-User/outlet-user/list" }]} /> : ""}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default OutletUserList